import { compose } from "redux";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography } from "@material-ui/core";

import { BasePage } from "altus-ui-components";

import {
  getCurrentUserFromState,
  getActionDataStateFromState,
} from "app/app.selectors";

import routePaths from "app/routePaths";
import background from "assets/login.jpg";
import { APP_ACTIONS } from "app/app.constants";
import LoadingButton from "app/components/LoadingButton";
import { loginPopup } from "features/login/login.actions";

class LoginContainer extends PureComponent {
  render() {
    const { classes, dispatchLoginPopup, currentUser, dataState } = this.props;

    return (
      <BasePage
        classes={{
          root: classes.root,
        }}
      >
        {currentUser.get("id") && <Redirect to={routePaths.root} />}
        <Grid item xs container justifyContent="center" alignItems="center">
          <Paper className={classes.paper}>
            <Grid container alignItems="center" spacing={4} direction="column">
              <Grid item>
                <Typography variant="h6">Authentication Required</Typography>
              </Grid>
              <Grid item>
                <Typography>You need to login to continue.</Typography>
              </Grid>
              <Grid item>
                <LoadingButton
                  size="large"
                  color="primary"
                  variant="contained"
                  onClick={dispatchLoginPopup}
                  loading={dataState.isLoading()}
                >
                  Login
                </LoadingButton>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </BasePage>
    );
  }
}

const styles = theme => ({
  paper: {
    padding: theme.spacing(5),
  },
  root: {
    padding: 0,
    "&:before": {
      top: 0,
      bottom: 0,
      zIndex: -1,
      opacity: 0.5,
      width: "100%",
      height: "100%",
      display: "block",
      position: "fixed",
      backgroundSize: "cover",
      filter: "saturate(50%)",
      content: "no-open-quote",
      backgroundPosition: "bottom",
      backgroundRepeat: "no-repeat",
      backgroundImage: `url("${background}")`,
    },
  },
});

export default compose(
  connect(
    state => ({
      currentUser: getCurrentUserFromState(state),
      dataState: getActionDataStateFromState(
        state,
        APP_ACTIONS.GET_CURRENT_USER,
      ),
    }),
    {
      dispatchLoginPopup: loginPopup,
    },
  ),
  withStyles(styles),
)(LoginContainer);
